import { render, staticRenderFns } from "./ekk_breadcrumb.vue?vue&type=template&id=cb535390&scoped=true"
import script from "./ekk_breadcrumb.vue?vue&type=script&lang=js"
export * from "./ekk_breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb535390",
  null
  
)

export default component.exports